import React from 'react';
import { Icon } from 'antd';
import BrandedLogo from '../../../../../../../../components/Logo/BrandedLogo';
import PoweredByLmiLogo from '../../../../../../../../components/Logo/PoweredByLmiLogo';
import { getPartnerContactEmail } from '../../../../../../../../themes/partnerTheme';
import './BackCover.scss';

export default () => (
  <section className="plan-preview-back-cover">
    <div className="company-intro">
      <div className="introduction">
        ContinuityCoach.com is structured and is updated where appropriate to reflect current best Business Continuity
        Management practice as stated in Business Continuity Institute Good Practice Guidelines &amp; International
        Organization for Standardization ISO 22301 Societal Security --- Business Continuity Management Systems ---
        Requirements.
      </div>
      <div className="company-intro-logos">
        <BrandedLogo className="plan-preview-back-cover__brand-logo" />
        <PoweredByLmiLogo className="plan-preview-back-cover__powered-by-logo" />
      </div>
    </div>
    <div className="company-info">
      <ul>
        <li>
          <span>{getPartnerContactEmail()}</span>
          <Icon type="mail" />
        </li>
        <li>
          <span>www.ContinuityCoach.com</span>
          <Icon type="home" />
        </li>
      </ul>
    </div>
  </section>
);
